import { formatCompactCount } from "./countryStats";

export const computeIndustryCounts = (opportunities = []) => {
  const counts = {};
  for (const opp of opportunities) {
    counts[opp.industry] = (counts[opp.industry] ?? 0) + 1;
  }
  return counts;
};

export const getSortedIndustriesWithCounts = (industries, opportunities, { includeEmpty = true } = {}) => {
  const counts = computeIndustryCounts(opportunities);
  const withCounts = (industries || []).map((i) => ({
    ...i,
    count: counts[i.name] ?? 0,
  }));
  const filtered = includeEmpty
    ? withCounts
    : withCounts.filter((i) => i.count > 0);
  return filtered.sort((a, b) => {
    if (b.count !== a.count) return b.count - a.count;
    const orderA = a.displayOrder ?? 9999;
    const orderB = b.displayOrder ?? 9999;
    if (orderA !== orderB) return orderA - orderB;
    return a.name.localeCompare(b.name, "ar");
  });
};

export { formatCompactCount };
